import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/protein-translation/pages/CalculatorPage";

export const Route = createFileRoute("/protein-translation")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/protein-translation",
      title: m.translate_meta_title(),
      description: m.translate_meta_description(),
      toolName: m.translate_tool_name(),
      faqs: [
        { q: m.translate_faq_q1(), a: m.translate_faq_a1() },
        { q: m.translate_faq_q2(), a: m.translate_faq_a2() },
        { q: m.translate_faq_q3(), a: m.translate_faq_a3() },
        { q: m.translate_faq_q4(), a: m.translate_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
